import { render, staticRenderFns } from "./EditorPreviewSwitcher.vue?vue&type=template&id=246a0a3b&"
import script from "./EditorPreviewSwitcher.vue?vue&type=script&lang=js&"
export * from "./EditorPreviewSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports